export enum InterpolationEnum {
  LINEAR = 'linear',
  NEAREST = 'nearest',
}
